module.exports = __webpack_public_path__ + "static/media/3D.7f9dd8b9.jpg";